var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMicWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.7 87.7",
    style: {
      enableBackground: "new 0 0 87.7 87.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .st0{fill:#ffffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.5,8C68.7-2.9,51.1-2.8,40.2,8c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.1-0.2,0.2                 c-6.1,6.4-8.5,15-7.3,23.1l-32.1,38c-0.5,0.6-0.5,1.5,0.1,2.1l15.4,15.4c0.3,0.3,0.7,0.5,1.1,0.5c0.4,0,0.7-0.1,1-0.4l38-32.1                 c1.3,0.2,2.7,0.3,4,0.3c6.9,0,13.8-2.6,19.1-7.7c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.3C90.3,36.5,90.3,18.9,79.5,8z                  M17,84L3.7,70.7l29.6-35c1.3,4.3,3.6,8.3,7,11.7c3.4,3.4,7.4,5.7,11.7,7L17,84z M42.5,45.2C33.7,36.4,33,22.7,40.2,13                 c2,8.4,6.2,15.9,12.4,22.1c6.2,6.2,13.7,10.4,22.1,12.4C65.1,54.7,51.3,54,42.5,45.2z M77.6,44.9c-8.7-1.6-16.6-5.7-22.9-12                 s-10.4-14.2-12-22.8c4.8-4.7,11-7,17.2-7c6.3,0,12.6,2.4,17.4,7.2C86.8,19.8,86.9,35.2,77.6,44.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMicWhite);
export default __webpack_public_path__ + "static/media/ico-micWhite.48f2942b90dff34029db94a7be58ed4e.svg";
export { ForwardRef as ReactComponent };